<template>
  <v-dialog
    :value="emailOutstandingInvoicesModal"
    persistent
    fullscreen
    @keydown.enter="email"
  >
    <v-card>
      <v-row>
        <v-col cols="6">
          <div class="settings">
            <label>Alles:</label
            ><input
              @change="viewOutstandingInvoices"
              type="checkbox"
              v-model="allDates"
            />
            <label>Vanaf:</label
            ><input
              @change="viewOutstandingInvoices"
              type="date"
              v-model="fromDate"
              :disabled="allDates"
            />
            <label>t/m:</label
            ><input
              @change="viewOutstandingInvoices"
              type="date"
              v-model="toDate"
              :disabled="allDates"
            />
            <label>Aan:</label><input type="text" v-model="headers.to" />
            <label>Bericht:</label>
            <vue-editor v-if="dataUrl" v-model="headers.html"></vue-editor>
          </div>
        </v-col>
        <v-col cols="6">
          <iframe
            :src="dataUrl"
            frameborder="0"
            id="iframe"
          ></iframe>
        </v-col>

        <v-footer fixed class="d-flex justify-center">
          <v-btn-toggle>
            <v-btn @click="closeEmailOutstandingInvoicesModal" color="primary"
              >Sluit</v-btn
            >
            <v-btn color="primary" @click="email">Mailen</v-btn>
          </v-btn-toggle>
        </v-footer>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from "vue2-editor"
import {
  viewOutstandingInvoices,
  emailOutstandingInvoices
} from "../js/pdfController"
import { errorHandler, fetchGET, fetchPOST, successHandler } from "../js/functions"
export default {
  name: "emailOutstandingInvoicesModal",
  props: {
    emailOutstandingInvoicesModal: Boolean,
    client: Object,
    data: Array
  },
  data() {
    return {
      outstandingInvoices: this.data,
      dataUrl: "",
      fromDate: new Date(Date.now()).toISOString().split("T")[0],
      toDate: new Date(Date.now()).toISOString().split("T")[0],
      allDates: true,
      headers: {
        subject: "Openstaande facturen",
        fileName: `Openstaande facturen ${new Date(
          Date.now()
        ).toLocaleDateString("nl-NL")}.pdf`,
        to: "",
        text: "",
        html: ""
      },
    }
  },
  methods: {
    async email() {
      try {
        this.closeEmailOutstandingInvoicesModal()
        let outstandingInvoices = this.allDates
          ? this.outstandingInvoices
          : this.outstandingInvoices.filter(
              invoice =>
                new Date(invoice.date) >= new Date(this.fromDate) &&
                new Date(invoice.date) <= new Date(this.toDate)
            )
        let buffer = await emailOutstandingInvoices(
          this.client,
          outstandingInvoices
        )
        let response = await fetchPOST("sendMail", {
          buffer: buffer,
          headers: this.headers
        })
        if (response.success) successHandler("Email verzonden")
          else throw "Email niet verzonden"
      } catch (e) {
        errorHandler(e,"Email niet verzonden")
      }
    },
    closeEmailOutstandingInvoicesModal() {
      URL.revokeObjectURL(this.dataUrl)
      this.$emit("close-email-outstanding-invoices-modal")
    },
    async viewOutstandingInvoices() {
      let outstandingInvoices = this.allDates
        ? this.outstandingInvoices
        : this.outstandingInvoices.filter(
            invoice =>
              new Date(invoice.date) >= new Date(this.fromDate) &&
              new Date(invoice.date) <= new Date(this.toDate)
          )
      let data = await viewOutstandingInvoices(this.client, outstandingInvoices)
      this.dataUrl = URL.createObjectURL(data)
    }
  },
  async mounted() {
    await this.viewOutstandingInvoices()
    this.headers.text = this.$store.state.settings.emailOutstandingInvoicesBody.text
    this.headers.html = this.$store.state.settings.emailOutstandingInvoicesBody.html
    let client = await fetchGET("findClient", this.client.clientNumber)
    this.headers.to = client.email
  },
  components: {
    VueEditor
  }
}
</script>

<style scoped>
div.settings {
  justify-content: space-evenly;
  font-size: 2em;
  display: grid;
  grid-template-columns: min-content min-content;
  grid-gap: 5px;
}
input[type="checkbox"] {
  height: 1em;
  width: 1em;
}
#iframe {
  height: 700px;
  width: 600px;
  margin: auto;
  padding: 0;
  display: block;
}
.hidden {
  width: 0;
  height: 0;
  overflow: hidden;
}
</style>